<template>
    <div class="kt-section" :class="{ 'kt-section--first': first, 'kt-section--last': last }">
        <div class="kt-section__body">
            <slot></slot>
        </div>
    </div>
</template>

<script setup lang="ts">
    defineProps<{
        first?: boolean;
        last?: boolean;
    }>();
</script>
